// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"heading_heading_wrapper__Fq9w_","heading":"heading_heading__nnHeT","short_description":"heading_short_description__F9zSx"};